/* eslint-disable @typescript-eslint/no-empty-function */
// Profider for the Confirm component

import { createContext, ReactNode, useState, useCallback, useMemo, useContext } from 'react';
import { Confirm, ConfirmProps } from './Confirm';

interface ConfirmContextProps {
  showConfirm: (confirm: ConfirmProps) => void;
}

const ConfirmContext = createContext<ConfirmContextProps>({
  showConfirm: () => {}
});

export const ConfirmProvider = ({ children }: { children: ReactNode }) => {
  const [confirm, setConfirm] = useState<ConfirmProps | null>(null);

  const showConfirm = useCallback((c: ConfirmProps) => {
    setConfirm(c);
  }, []);

  const providerValue = useMemo(() => ({ showConfirm }), [showConfirm]);

  return (
    <ConfirmContext.Provider value={providerValue}>
      {children}
      {confirm &&
        (confirm.onConfirm ? (
          <Confirm
            {...confirm}
            onCancel={() => {
              setConfirm(null);
              confirm.onCancel?.();
            }}
            onConfirm={async () => {
              if (confirm?.onConfirm) {
                const ok = confirm.onConfirm();
                if (ok) setConfirm(null);
                return ok;
              }
            }}
          />
        ) : (
          <Confirm
            {...confirm}
            onCancel={() => {
              setConfirm(null);
              confirm.onCancel?.();
            }}
          />
        ))}
    </ConfirmContext.Provider>
  );
};

export const useConfirm = () => useContext(ConfirmContext);

ConfirmProvider.displayName = 'ConfirmProvider';
